module.exports = __webpack_public_path__ + "static/media/00.15cb6fe2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/japan-three/00.jpg
// module id = 148
// module chunks = 0